import { parseISO, format, subDays, isBefore, isAfter, startOfDay } from 'date-fns';

const urgentJobTypes = ['UrgentJobSchedule', 'UrgentNannyJobSchedule'];

export class JobPresenter {
  public job: any;

  constructor(job: any) {
    this.job = job;
  }

  isEligible(): boolean {
    if (['UNKNOWN', 'JOB_STATUS_UNKNOWN', 'PENDING'].includes(this.job.status)) return false;

    let expDate: Date;
    if (['CLOSED', 'JOB_STATUS_CLOSED'].includes(this.job.status)) {
      expDate = parseISO(this.job.updatedAt);
    } else {
      expDate = parseISO(this.job.expiresAt);
    }

    const cutoff = subDays(new Date(), 2);

    // is the cutoff less than or equal to the expiry?
    return !isAfter(cutoff, expDate);
  }

  dateDescription(): string {
    if (['CLOSED', 'JOB_STATUS_CLOSED'].includes(this.job.status)) {
      const updatedAt = parseISO(this.job.updatedAt);
      const formatted = format(updatedAt, 'EEEE, MMMM d');
      return `Closed on ${formatted}`;
    }

    if (!this.job.isActive && this.job.status !== 'PENDING') {
      const expiresAt = parseISO(this.job.expiresAt);
      const formatted = format(expiresAt, 'EEEE, MMMM d');
      return `Expired on ${formatted}`;
    }

    const { schedule } = this.job;
    // Prioritize displaying a scheduled start date, ahead of displaying flexibility/urgency.
    if (schedule.startDate) {
      const startDate = parseISO(schedule.startDate);
      const expiry = startOfDay(new Date());

      if (isBefore(startDate, expiry)) return 'Start date has passed. Edit or close job.';

      const formattedDate = format(startDate, 'EEEE, MMMM d');
      const startPhrase = schedule.__typename === 'OneTimeJobSchedule' ? 'One time on' : 'Starts';
      return `${startPhrase} ${formattedDate}`;
    }

    return urgentJobTypes.includes(schedule.__typename) ? 'Starts ASAP' : 'Flexible start date';
  }
}

export default JobPresenter;
